<div class="main">
  <div class="left" [ngClass]="isAtLeastMedium ? 'flex-basis-45' : 'flex-basis-100'">
    <div class="body">
      <ng-content select="[layout-body]"></ng-content>
    </div>
    <div class="footer">
      <div>© Energies Demain</div>
      <div class="contact"><i class="fa fa-envelope-open-o" ></i>contact&#64;energies-demain.com</div>
    </div>
  </div>

  <div class="right" [ngClass]="isAtLeastMedium ? 'd-flex' : 'd-none'">
    <div class="slogan-container d-flex justify-content-center">
      <div class="logo">
        <img src="../../../assets/img/header/siterre_logo_blue.svg" alt="logo" />
      </div>
      <div class="slogan-text p-3">
        Le système d’information territoriale écologique
      </div>
    </div>
    <div class="image-container">
      <div class="image"></div>
    </div>
  </div>
</div>